import React, { useState } from "react";
import { Link } from "react-scroll";
import logo from "../assets/logo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="bg-gradient-to-b to-gray-900 from-black text-white fixed w-full z-50 py-2">
      <div className="container mx-auto flex justify-between items-center px-6 py-4">
        {/* Logo */}
        <div className="flex items-center space-x-2">
          {/* <Link to="home" smooth={true} duration={500}>
            <img
              src={logo}
              alt="Company Logo"
              width={55}
              className="rounded-full cursor-pointer"
            />
          </Link> */}
          <span className="text-2xl font-bold tracking-wide text-yellow-400">
            We see you
          </span>
        </div>

        {/* Desktop Menu */}
        <ul className="hidden md:flex space-x-6">
          {["Home", "About", "Projects", "WebSites", "Skills", "Contact"].map(
            (item) => (
              <li key={item}>
                <Link
                  to={item.toLowerCase()}
                  smooth={true}
                  duration={500}
                  className="cursor-pointer hover:text-accent transition-transform transform hover:scale-110"
                  activeClass="text-accent" // Highlight active link
                  spy={true} // Enable active link highlighting
                >
                  {item}
                </Link>
              </li>
            )
          )}
        </ul>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button
            className="text-2xl focus:outline-none"
            onClick={toggleMenu}
            aria-expanded={isOpen ? "true" : "false"}
            aria-label="Toggle menu"
          >
            {isOpen ? (
              <span className="text-3xl">✖</span>
            ) : (
              <span className="text-3xl">☰</span>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu with Animation */}
      <div
        className={`fixed inset-0 bg-primary bg-opacity-95 transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out md:hidden -z-40`}
      >
        <ul className="flex flex-col items-center justify-start h-screen space-y-8 text-xl mt-40">
          {["Home", "About", "Projects", "Skills", "Contact"].map((item) => (
            <li key={item}>
              <Link
                to={item.toLowerCase()}
                smooth={true}
                duration={500}
                className="cursor-pointer hover:text-accent transition-transform transform hover:scale-110"
                onClick={toggleMenu} // Close menu on link click
                activeClass="text-accent"
                spy={true}
              >
                {item}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
